class DeactivateOrganizationWorkflow {
	constructor(
		public readonly organizationId: number,
		public readonly workflowKey: string,
	) {
		Object.freeze(this);
	}

	// Both identifiers are route segments; the endpoint takes no body.
	toJSON(): Record<string, unknown> {
		return {};
	}
}

export default DeactivateOrganizationWorkflow;
